module.exports = __webpack_public_path__ + "img/graph_sp.44bee85.svg";